module.exports = __webpack_public_path__ + "static/img/shebeichanpindi9ngzhifuwu.d7b0a97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shebeichanpindi9ngzhifuwu.png
// module id = H1qQ
// module chunks = 1